<template>
  <v-row justify="center" v-if="inscripcion">
    <v-dialog v-model="dialog" persistent scrollable fullscreen>
      <v-card tile>
        <v-toolbar dark color="primary" dense flat class="max-height">
          <v-spacer></v-spacer>
          <v-toolbar-title class="white--text"> DETALLE DE INSCRIPCION </v-toolbar-title>
          <v-spacer></v-spacer>
        </v-toolbar>
 
        <v-card-text> 
          <p v-if="programa" class="text-center my-1 h4 black--text">{{ programa.nombre_compuesto.toUpperCase() }}</p>
          <v-row>
            <v-col md="6" sm="12" v-if="inscripcion.estudiante">
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Numero Documento: </span> {{ inscripcion.estudiante.num_doc }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Nombres : </span>
                {{ inscripcion.estudiante.nombres }}
                {{ inscripcion.estudiante.pri_apellido }}
                {{ inscripcion.estudiante.seg_apellido }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Domicilio : </span> {{ inscripcion.estudiante.domicilio }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Telefono : </span> {{ inscripcion.estudiante.telefono1 }}
                {{ inscripcion.estudiante.telefono2 ? `, ${inscripcion.estudiante.telefono2}` : '' }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Email : </span> {{ inscripcion.estudiante.email }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Fecha Nacimiento </span> :
                {{ formatDate(inscripcion.estudiante.fecha_nac) }}
              </p>
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Contacto : </span> {{ inscripcion.estudiante.contacto }}
              </p>
              <!-- <p class="py-0 my-0">
                <span class="font-weight-bold"> Estado : </span>
                {{ inscripcion.estudiante.estado ? 'Activo' : 'Suspendido' }}
              </p> -->
              <p class="py-0 my-0">
                <span class="font-weight-bold"> Estado : </span>
                {{ parseIns(inscripcion.estado_ins) }}
              </p>
              <p v-if="programa">
                <span class="font-weight-bold"> Codigos :</span>
                {{ `${programa.nombre_compuesto.slice(0, 1)}-${programa.id}` }}, Ins: {{ inscripcion.id }}
              </p>
              <p>
                <v-tooltip top v-if="inscripcion && inscripcion.plan_pagos.length">
                  <template #activator="{ on, attrs }">
                    <v-btn color="success" small rounded v-bind="attrs" @click="openDialogKardex()" v-on="on">
                      <v-icon class="mx-2"> mdi-table-eye</v-icon> Ver Kardex de Pagos
                    </v-btn>
                  </template>
                  Generar Kardex
                </v-tooltip>
              </p>
              <p>
                <v-tooltip top v-if="inscripcion && inscripcion.plan_pagos.length && is_upi_avd">
                  <template #activator="{ on, attrs }">
                    <v-btn color="orange" dark small rounded v-bind="attrs" @click="generar_nuevo_q()" v-on="on">
                      <v-icon class="mx-2"> mdi-refresh</v-icon> Generar nuevo Q
                    </v-btn>
                  </template>
                  Generar plan de pagos al nuevo Cuatrimestre
                </v-tooltip>
              </p>
            </v-col>

            <v-col md="6" sm="12" v-if="inscripcion.plan_programa">
              <v-data-table
                :headers="headPlanCobro"
                :items="inscripcion.plan_programa.cobros_programa"
                :loading="loading"
                hide-default-footer
                disable-pagination
                class="elevation-10">
                <template v-slot:top>
                  <p class="h4 text-center pt-2">
                    PLAN COBRO: <span class="orange--text">{{ inscripcion.plan_programa.nombre.toUpperCase() }}</span>
                  </p>
                </template>
              </v-data-table>
            </v-col>

            <v-col v-if="recibos.length > 0 || existRecibo" cols="12" class="my-0 py-0">
              <v-expansion-panels v-model="panel" multiple>
                <v-expansion-panel>
                  <v-expansion-panel-header color="" class="red--text font-weight-bold">
                    {{ 'El Estudiante ya tiene recibos en esta programa'.toUpperCase() }} 
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <my-recibos
                      ref="refMyRecibos"
                      @closeDialog="closeDialog"
                      v-if="recibos.length > 0"
                      :RecibosGenerados="recibos"
                      :plan-pagos="inscripcion.plan_pagos"></my-recibos>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-col>
            <v-col cols="12" v-if="inscripcion">
              <pago-saldo-detail :inscripcion_id="inscripcion.id" />
            </v-col>
            <v-col class="mb-0 pb-0">
              <v-alert dense outlined type="success" class="mb-0" v-if="xpromo.nombre">
                <h3 class="my-0">Promoción aplicada:</h3>
                <v-row no-gutters>
                  <v-col cols="12" sm="4">
                    <p class="mb-0 mt-2"><b class="black--text">Nombre promo: </b> {{ xpromo.nombre }}</p>
                    <p class="mb-0"><b class="black--text">Descripcion: </b> {{ xpromo.descripcion }}</p>
                    <p class="mb-0"><b class="black--text">Creado por: </b> {{ xpromo.creado_por }}</p>
                    <p class="mb-0"><b class="black--text">Aprobado por: </b> {{ xpromo.aprobado_por }}</p>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <p class="mb-0"><b class="black--text">Fecha inicio: </b> {{ xpromo.fecha_inicio }}</p>
                    <p class="mb-0"><b class="black--text">Fecha finalizacion: </b> {{ xpromo.fecha_fin }}</p>
                    <v-divider class="my-1"></v-divider>
                    <p class="mb-0 ml-6" v-for="(d, ind) in xpromo.detalle_promocion" :key="ind">
                      <b class="purple--text"> {{ d.nombre_concepto }}: </b> {{ d.valor_descuento }}
                      {{ d.is_porcentaje ? '%' : getMonedaStr() }} de descuento.
                    </p>
                  </v-col> 
                </v-row>
              </v-alert>
              <p v-else class="mb-0">Sin promoción aplicada.</p>
            </v-col>
            <v-col :md="inscripcion.plan_programa ? 12 : 6" class="my-0 py-0 mb-4">
              <template v-if="is_upi_avd">
                <v-tabs v-model="active_tab" @change="onTabChange" background-color="primary" dark>
                  <v-tab>Plan General</v-tab>
                  <v-tab v-for="plan in planes_q" :key="plan.id">
                    Plan {{ plan.nro_plan }}
                    <v-chip x-small class="ml-1" :color="plan.aprobado ? 'success' : 'warning'">
                      {{ plan.aprobado ? 'Aprobado' : 'Pendiente' }}
                    </v-chip>
                  </v-tab>
                </v-tabs>
                <v-tabs-items v-model="active_tab">
                  <v-tab-item>
                    <v-data-table
                      v-if="inscripcion.plan_programa"
                      :headers="headPlanPagosQS"
                      :items="plan_pagos"
                      :group-by="'plan_pago_grupo_id'"
                      hide-default-footer
                      disable-pagination
                      class="elevation-10">
                      <template v-slot:top><p class="h4 text-center pt-2 black--text">PLAN DE PAGOS GENERADO</p></template>
                      <template v-slot:[`group.header`]="{ group, toggle, isOpen }">
                        <td :colspan="headPlanPagosQS.length" class="primary white--text pl-3" style="cursor:pointer" @click="toggle">
                          <v-icon small color="white" class="mr-1">{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                          {{ getGrupoLabel(group) }}
                        </td>
                      </template>
                      <template v-slot:[`item.date_pago`]="{ item }">
                        <label class="" @click="openDialogChangeDate(item)">{{ item.date_pago }}</label>
                      </template>
                      <template v-slot:no-data>
                        <div role="listbox" tabindex="-1" class="v-list v-select-list v-sheet theme--light v-list--dense theme--light">
                          <div tabindex="-1" class="v-list-item theme--light">
                            <div class="v-list-item__content">
                              <div class="v-list-item__title">ESTE ESTUDIANTE NO TIENE PLAN DE PAGOS</div>
                            </div>
                          </div>
                        </div>
                      </template>
                    </v-data-table>
                    <v-progress-linear v-if="loading_plan_pagos" height="4" indeterminate color="indigo"></v-progress-linear>
                  </v-tab-item>
                  <v-tab-item v-for="plan in planes_q" :key="plan.id">
                    <v-card flat>
                      <v-card-text class="pb-1">
                        <p class="mb-1">
                          <b>Motivo:</b> {{ plan.motivo }}
                          <span v-if="plan.motivo_detalle"> — {{ plan.motivo_detalle }}</span>
                        </p>
                        <p class="mb-1">
                          <b>Total cuotas:</b> {{ plan.total_cuotas }} &nbsp;
                          <b>Estado:</b>
                          <v-chip x-small :color="plan.aprobado ? 'success' : 'warning'" dark class="ml-1">
                            {{ plan.aprobado ? 'Aprobado' : 'Pendiente' }}
                          </v-chip>
                          <v-btn
                            v-if="!plan.aprobado"
                            color="success"
                            small
                            rounded
                            class="ml-3"
                            @click="openAprobarDialog(plan)">
                            <v-icon small class="mr-1">mdi-check-circle</v-icon> Aprobar Plan
                          </v-btn>
                        </p>
                      </v-card-text>
                      <v-progress-linear v-if="loading_planes_q" height="4" indeterminate color="indigo"></v-progress-linear>
                      <v-data-table
                        :headers="headPlanPagosQ"
                        :items="planes_q_cuotas[plan.id] || []"
                        hide-default-footer
                        disable-pagination
                        class="elevation-10">
                        <template v-slot:top>
                          <p class="h4 text-center pt-2 black--text">CUOTAS DEL PLAN {{ plan.nro_plan }}</p>
                        </template>
                      </v-data-table>
                    </v-card>
                  </v-tab-item>
                </v-tabs-items>
              </template>
              <template v-else>
                <v-data-table
                  v-if="inscripcion.plan_programa"
                  :headers="headPlanPagosQS"
                  :items="plan_pagos"
                  :group-by="'plan_pago_grupo_id'"
                  hide-default-footer
                  disable-pagination
                  class="elevation-10">
                  <template v-slot:top><p class="h4 text-center pt-2 black--text">PLAN DE PAGOS GENERADO</p></template>
                  <template v-slot:[`group.header`]="{ group, toggle, isOpen }">
                    <td :colspan="headPlanPagosQS.length" class="primary white--text pl-3" style="cursor:pointer" @click="toggle">
                      <v-icon small color="white" class="mr-1">{{ isOpen ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                      {{ getGrupoLabel(group) }}
                    </td>
                  </template>
                  <template v-slot:[`item.date_pago`]="{ item }">
                    <label class="" @click="openDialogChangeDate(item)">{{ item.date_pago }}</label>
                  </template>
                  <template v-slot:no-data>
                    <div role="listbox" tabindex="-1" class="v-list v-select-list v-sheet theme--light v-list--dense theme--light">
                      <div tabindex="-1" class="v-list-item theme--light">
                        <div class="v-list-item__content">
                          <div class="v-list-item__title">ESTE ESTUDIANTE NO TIENE PLAN DE PAGOS</div>
                        </div>
                      </div>
                    </div>
                  </template>
                </v-data-table>
                <v-progress-linear v-if="loading_plan_pagos" height="4" indeterminate color="indigo"></v-progress-linear>
              </template>
            </v-col>
          </v-row>

          <v-data-table
            :headers="headDescuentos"
            :items="descuentos"
            :loading="loading_descuentos"
            hide-default-footer
            disable-pagination
            class="elevation-4 mt-8">
            <template v-slot:top>
              <p class="h4 text-center pt-3">DESCUENTOS APROBADOS</p>
            </template>
            <template v-slot:[`item.monto`]="{ item }">
              {{ getMonedaStr() }} {{ item.monto }}
            </template>
            <template v-slot:[`item.prorrateadoActivo`]="{ item }">
              <v-chip x-small :color="item.prorrateadoActivo ? 'blue lighten-4' : 'grey lighten-3'">
                {{ item.prorrateadoActivo ? 'Sí' : 'No' }}
              </v-chip>
            </template>
            <template v-slot:[`item.user_solicitante`]="{ item }">
              <span v-if="item.user_solicitante">
                {{ item.user_solicitante.nombres }} {{ item.user_solicitante.primer_apellido }}
              </span>
            </template>
            <template v-slot:[`item.user_responsable`]="{ item }">
              <span v-if="item.user_responsable">
                {{ item.user_responsable.nombres }} {{ item.user_responsable.primer_apellido }}
              </span>
            </template>
            <template v-slot:[`item.estado`]="{ item }">
              <v-chip x-small color="success" dark>{{ item.estado }}</v-chip>
            </template>
          </v-data-table>

          <v-data-table
            v-if="inscripcion.more_programas"
            :headers="headProgramas"
            :items="inscripcion.more_programas"
            hide-default-footer
            disable-pagination
            class="elevation-13">
            <template v-slot:top> <p class="h4 text-center pt-3">PROGRAMAS ADICIONALES CURSADOS</p></template>
          </v-data-table> 

        </v-card-text>
        <v-divider class="mt-0"></v-divider> 
        <v-card-actions>
          <template v-if="inscripcion.plan_pagos.length > 0">
            <!-- <v-btn v-if="!existRecibo" color="red" rounded @click="eliminarPlan"> <v-icon class="mr-1"> mdi-delete</v-icon> Eliminar de plan </v-btn> -->
            <v-btn v-if="existRecibo && programa && inscripcion" color="success" rounded @click="generatePlan2(true)">
              <v-icon class="mr-1">mdi-sync</v-icon> Realizar cambio de plan
            </v-btn>
            <v-btn
              v-if="!$store.state.isonlyread && !existRecibo && programa && inscripcion"
              color="primary"
              rounded
              @click="generatePlan(true)">
              <v-icon class="mr-1">mdi-sync</v-icon> Cambiar de plan
            </v-btn>
            <v-btn v-if="canRegularizar" color="amber" rounded @click="openRegularizar">
              <v-icon class="mr-1">mdi-sync</v-icon> Regularizacion
            </v-btn>
          </template>
          <template v-else>
            <!-- solo si el usuario es de contabilidad -->
            <p class="pl-5 red--text h4 font-weight-bold" v-if="!inscripcion.estado_inscripcion">PREINSCRITO</p>
          </template>

          <v-spacer></v-spacer>

          <v-btn color="blue darken-1" outlined rounded @click="closeDialog">
            Cerrar <v-icon class="mx-2"> mdi-close</v-icon>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog v-model="dialogAprobar" max-width="420" persistent>
      <v-card>
        <v-card-title class="text-h6">Confirmar aprobación</v-card-title>
        <v-card-text>
          ¿Desea aprobar el <b>Plan {{ planAprobar ? planAprobar.nro_plan : '' }}</b>? Esta acción no se puede revertir.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogAprobar = false" :disabled="loading_aprobar">Cancelar</v-btn>
          <v-btn color="success" rounded :loading="loading_aprobar" @click="aprobarPlan">
            <v-icon small class="mr-1">mdi-check-circle</v-icon> Confirmar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <kardex-pagos v-bind.sync="oneCuota" ref="refKardex"></kardex-pagos>
    <change-date-cuota v-bind.sync="oneCuota" ref="refChangeDate" />
    <view-regularizacion @closeDialog="closeDialog" ref="refViewRegularizacion" />
  </v-row>
</template>

<script>
  import xaxios from '@/xaxios';
  import gql from 'graphql-tag';
  import MyRecibos from '../programas/MyRecibos.vue';
  import KardexPagos from '../recibos/KardexPagos.vue';
  import ChangeDateCuota from '../programas/ChangeDateCuota.vue';
  import PagoSaldoDetail from './PagoSaldoDetail.vue';
  import { mapState } from 'vuex';
  import ViewRegularizacion from './ViewRegularizacion.vue';
  import { concepto_ids_orden } from '@/views/upi/planes/utils'
  
  export default {
    components: { MyRecibos, KardexPagos, ChangeDateCuota, PagoSaldoDetail, ViewRegularizacion },
    data() {
      return {
        menu_name: process.env.VUE_APP_NAME_MENU,
        api_rest: process.env.VUE_APP_API_REST,
        padre: {},

        dialog: false,
        existRecibo: false,
        loading: false,
        panel: [0],
        oneCuota: null,
        inscripcion: { plan_pagos: [] },
        cobro: null,
        plan_pagos: [],
        loading_plan_pagos: false,
        active_tab: 0,
        planes_q: [],
        planes_q_cuotas: {},
        loading_planes_q: false,
        dialogAprobar: false,
        planAprobar: null,
        loading_aprobar: false,
        headPlanPagosQ: [
          { text: 'Concepto', value: 'ConceptoPago' },
          { text: 'N°Cuota', value: 'NroCuota' },
          { text: 'Monto', value: 'monto' },
          { text: 'Saldo', value: 'Saldo' },
          { text: 'Fecha Vencimiento', value: 'FechaPago' },
        ],
        recibos: [],
        programas: [],
        xpromo: {},
        headPlanCobro: [
          { text: 'Nombre', value: 'concepto_pago.nombre' },
          { text: 'Monto', value: 'monto' },
          { text: 'Cuotas', value: 'cuotas' },
        ],
        headPlanPagosGraphql: [
          // { text: 'Codigo Cuota', value: 'plan_pago_id' },
          { text: 'Concepto', value: 'concepto_pago.nombre' },
          { text: 'N°Cuota', value: 'nro_cuota' },
          { text: 'Monto', value: 'monto' },
          { text: 'Descuento', value: 'descuento' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'Fecha Vencimiento', value: 'fecha_pago' },
        ],
        headPlanPagosQS: [
          { text: 'Concepto', value: 'concepto_pago' },
          { text: 'N°Cuota', value: 'nro_cuota' },
          { text: 'Total', value: 'total' },
          { text: 'Monto Pagado', value: 'monto_pagado' },
          { text: 'Monto Descuento', value: 'monto_descuento' },
          { text: 'Monto Regularizado', value: 'monto_regularizado' },
          { text: 'Monto Compensacion', value: 'monto_compensacion' },
          { text: 'Monto Liquido', value: 'monto_liquido' },
          { text: 'Saldo', value: 'saldo' },
          { text: 'Fecha Vencimiento', value: 'date_pago' },
        ],
        headProgramas: [
          { text: 'Gestion', value: 'gestion' },
          { text: 'Sede', value: 'sede.nombre' },
          { text: 'Codigo', value: 'id' },
          { text: 'Programa', value: 'nombre_compuesto' },
        ],
        descuentos: [],
        loading_descuentos: false,
        headDescuentos: [
          { text: 'Monto', value: 'monto' },
          { text: 'Descripción', value: 'descripcion' },
          { text: 'Fecha Registro', value: 'fecha_registro' },
          { text: 'Prorrateado', value: 'prorrateadoActivo' },
          { text: 'Solicitante', value: 'user_solicitante' },
          { text: 'Responsable', value: 'user_responsable' },
          { text: 'Estado', value: 'estado' },
        ],
      };
    },
    computed: {
      ...mapState({
        programa: (state) => {
          // window.console.log(state.programa.value);
          return state.programa.value;
        },
      }),
      canRegularizar() {
        return (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) && this.inscripcion;
      },
      is_upi_avd() {
        if (!this.programa) return false;
        const idsede = this.$store.state.CARGO.sede.id;
        return idsede == 82 && this.programa.nombre_compuesto.includes('U301 AVANZADO)');
      },
    },
    watch: {
      dialog(val) {
        if (!val) this.xpromo.nombre = null;
        val || this.closeDialog();
      },
    },
    methods: {
      async showThisView(persona_id, inscripcion_id, padre) {
        //if (!this.$store.state.nombre_compuesto) this.$store.state.nombre_compuesto = '';
        this.xpromo.id = null;
        this.xpromo.ambiente = null;
        this.xpromo.aprobado_por = null;
        this.xpromo.creado_por = null;
        this.xpromo.descripcion = null;
        this.xpromo.estado = null;
        this.xpromo.fecha_fin = null;
        this.xpromo.fecha_inicio = null;
        this.xpromo.nombre = null;
        this.active_tab = 0;
        this.planes_q = [];
        this.planes_q_cuotas = {};
        this.padre = padre;
        this.loading_plan_pagos = true;
        this.loading = true;
        this.dialog = true;

        xaxios
          .post(`${this.api_rest}/api/pagos/recibos/buscar/inscripcion`, { inscripcion_id: inscripcion_id })
          .then(({ data }) => (this.recibos = data ? data : []));

        let xplanes = await xaxios
          .get(`${this.api_rest}/api/v1/inscripcion/${inscripcion_id}/plan-pago`)
          .then(({ data: { data } }) => {
            //window.console.log('datt', JSON.stringify(data, null, 4));
            window.console.log('data plan pagos: ', data);

            this.loading_plan_pagos = false;
            return data.length
              ? data.map((item) => {
                item.monto_pagado = parseFloat(Number(item.monto_pagado).toFixed(2))
                  const total = Number(item.total) || 0;
                  const monto_pagado = Number(item.monto_pagado) || 0;
                  const monto_descuento = Number(item.monto_descuento) || 0;
                  const monto_regularizado = Number(item.monto_regularizado) || 0;
                  const monto_compensacion = Number(item.monto_compensacion) || 0;
                  const monto_liquido = Number(item.monto_liquido) || 0;

                  return {
                    ...item,
                    saldo: parseFloat(
                      (
                        total -
                        (monto_pagado +
                          monto_descuento +
                          monto_regularizado +
                          monto_compensacion +
                          monto_liquido)
                      ).toFixed(2)
                    ),
                    date_pago: this.formatDate(item.fecha_pago),
                  };
                })
              : [];
          })
          .catch(() => {
            this.loading_plan_pagos = false;
            return [];
          });

        //window.console.log('planes:', xplanes, `${this.api_rest}/api/v1/inscripcion/${inscripcion_id}/plan-pago`);
        window.console.log('\nxplanessss', xplanes);
        const unidad = this.$store.state.CARGO.sede.unidad_negocio;
        
        if(unidad == 15){
          const prioridad = new Map(
            concepto_ids_orden.map((id, index) => [id, index])
          );
          xplanes.sort((a, b) => {
            if (a.order != null && b.order != null && a.order !== b.order) return a.order - b.order;
            return (prioridad.get(a.concepto_pago_id) ?? Infinity)
                - (prioridad.get(b.concepto_pago_id) ?? Infinity);
          });
        }else{
          xplanes.sort((a, b) => {
            if (a.order != null && b.order != null && a.order !== b.order) return a.order - b.order;
            // QUITAR ESTO EN PRODUCCION CUANDO EL ENDPOINT ESTE EL concepto_pago_id
            if (!a.concepto_pago_id) {
              if (a.concepto_pago == 'Matrícula') a.concepto_pago_id = 1;
              else if (a.concepto_pago == 'Colegiatura') a.concepto_pago_id = 2;
              else if (a.concepto_pago == 'Certificación') a.concepto_pago_id = 3;
            }
            if (!b.concepto_pago_id) {
              if (b.concepto_pago == 'Matrícula') b.concepto_pago_id = 1;
              else if (b.concepto_pago == 'Colegiatura') b.concepto_pago_id = 2;
              else if (b.concepto_pago == 'Certificación') b.concepto_pago_id = 3;
            }
            return a.concepto_pago_id - b.concepto_pago_id || a.numero_cuota - b.numero_cuota;
          });
        }
        
        this.plan_pagos = xplanes;

        this.inscripcion = await this.get_data_inscripcion(inscripcion_id);
        if (!this.inscripcion.plan_pagos) this.inscripcion.plan_pagos = [];
        window.console.log('......', this.inscripcion, inscripcion_id);
        this.inscripcion.plan_pagos.forEach((plan) => {
          if (plan.monto != plan.saldo) {
            this.existRecibo = true;
            return;
          }
        });
        this.dialog = true;
        this.listar_descuentos_aprobados();
        this.loading = false;

        if (this.is_upi_avd) {
          this.cargar_planes_q(inscripcion_id);
        }
        // window.console.log('this.inscripcion', JSON.stringify(this.inscripcion));
        // window.console.log('plan_pagos', JSON.stringify(this.plan_pagos));
      },
      getGrupoLabel(grupo_id) {
        if (!grupo_id) return 'Plan Principal';
        const plan = this.planes_q.find(p => p.id == grupo_id);
        return plan ? `Plan ${plan.nro_plan} — ${plan.motivo}` : `Plan #${grupo_id}`;
      },
      async cargar_planes_q(inscripcion_id) {
        const { data } = await xaxios
          .get(`${this.api_rest}/api/esam/inscripcion/id/${inscripcion_id}/planes`)
          .catch(() => ({ data: [] }));
        this.planes_q = Array.isArray(data) ? data : [];
      },
      async onTabChange(tab) {
        if (tab === 0) return;
        const plan = this.planes_q[tab - 1];
        if (!plan || this.planes_q_cuotas[plan.id]) return;
        this.loading_planes_q = true;
        const { data } = await xaxios
          .get(`${this.api_rest}/api/esam/inscripcion/plan/id/${plan.id}`)
          .catch(() => ({ data: null }));
        if (data && data.cuotas) {
          data.cuotas.map(x=>{
            x.monto = +(Number(x.monto)).toFixed(2),
            x.Saldo = +(Number(x.Saldo)).toFixed(2)
          })
          this.$set(this.planes_q_cuotas, plan.id, data.cuotas);
        }
        this.loading_planes_q = false;
      },
      openDialogKardex() {
        //window.console.log(JSON.stringify(this.inscripcion.plan_pagos,null,4))
        this.inscripcion.plan_pagos.sort((a, b) => {
          if (!a.concepto_pago) a.concepto_pago = {};
          if (!b.concepto_pago) b.concepto_pago = {};
          return a.concepto_pago.id - b.concepto_pago.id || a.nro_cuota - b.nro_cuota;
        });
        this.$refs.refKardex.showThisView(
          this.inscripcion.estudiante,
          this.inscripcion.plan_programa,
          this.inscripcion.plan_pagos,
          this.inscripcion.programa,
          this.inscripcion.id,
        );
      },
      openRegularizar() {
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if (unidad == 2) {
          let userid = this.$store.state.DATA_USER.id;
          let cargoid = this.$store.state.CARGO.id;
          let userperm = userid == 52023 || userid == 870 || userid == 18491 || userid == 89251 || userid == 54960 || cargoid == 1 || userid == 52394;
          if (!userperm) {
            // nicole andrade, nataly soruco
            this.$root.$notify.show(`No tiene autorizacion para esta accion`, { color: 'danger', x: 'left' });
            return;
          }
        }

        if (this.inscripcion) {
          this.inscripcion.plan_pagos.sort((a, b) => {
            if (!a.concepto_pago) a.concepto_pago = {};
            if (!b.concepto_pago) b.concepto_pago = {};
            return a.concepto_pago.id - b.concepto_pago.id || a.nro_cuota - b.nro_cuota;
          });
          this.inscripcion.plan_pagos = this.inscripcion.plan_pagos.map((pp) => ({
            ...pp,
            date_pago: this.formatDate(pp.fecha_pago),
          }));
          
          // window.console.log('>>>', this.inscripcion.plan_pagos);
          // window.console.log('>>><<<', this.plan_pagos);
          
          const pl = this.plan_pagos
          this.inscripcion.plan_pagos.forEach(p=>{
            const o = pl.find(x=>x.concepto_pago_id==p.concepto_pago.id)
            // window.console.log("--------->>",p, o);
            
            if(o) p.xorder = o.order
          })
          this.$refs.refViewRegularizacion.showThisView(this.inscripcion);
        }
      },
      openDialogChangeDate(cuota) {
        window.console.log('cuotita',cuota)
        // solicitado para que nadie pueda editar fechas
        /*if (this.$store.state.CARGO.id == 1 || this.$store.state.CARGO.id == 14) {
          this.oneCuota = cuota;
          this.$refs.refChangeDate.showThisView(this.inscripcion, cuota);
        }*/
      },
      formatDate(date) {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        return `${day}/${month}/${year}`;
      },
      itemRowBackgroundMora(item) {
        if (item.descuento > 0) {
          return 'descuento';
        }
        let fecha_pago = new Date(item.fecha_pago);
        fecha_pago.setDate(fecha_pago.getDate() + 1);

        let fecha_mes = new Date(item.fecha_pago);
        fecha_mes.setMonth(fecha_mes.getMonth() + 1);

        if (fecha_mes < new Date() && item.saldo != 0) return 'mora-mes-1';
        if (fecha_pago < new Date() && item.saldo != 0) return 'mora-semana-1';
        return item.saldo_regularizado ? 'regularizado' : '';
      },

      get_data_inscripcion(id) {
        this.getPromoAplicada(id);
        if (this.padre) this.padre.loadinddeta = true;
        const sql = gql`query{ getInscripcion(id:${id}){
            id,idprograma,idestudiante,estado_ins,observaciones,idasesor,fecha_registro,registrado_por,tipopago,puede_cambiar
            asesor {id nombres pri_apellido seg_apellido}
            estudiante {id num_doc nombres pri_apellido seg_apellido domicilio telefono1 telefono2 email fecha_nac contacto estado}
            programa {nombre_compuesto,universidad{id,nombre}}
            plan_programa {id nombre aprobado, cobros_programa{ id monto cuotas estado concepto_pago{id,nombre} }}
            plan_pagos { id monto saldo nro_cuota descuento fecha_pago bloqueado saldo_regularizado concepto_pago{id,nombre}}
            more_programas{ id, nombre_compuesto sede{ id nombre} gestion}
            # pagos_inscripcion {}
        }}`;
        return this.$apollo
          .query({ query: sql })
          .then(({ data }) => {
            //window.console.log(this.programa.id, 'dfsfs');
            if (!data.getInscripcion.more_programas) data.getInscripcion.more_programas = [];

            data.getInscripcion.more_programas = data.getInscripcion.more_programas.filter(
              (x) => x.id != this.programa.id,
            );
            if (this.padre) this.padre.loadinddeta = false;
            return data.getInscripcion;
          })
          .catch((e) => {
            window.console.log('------------', e);
            if (this.padre) this.padre.loadinddeta = false;
            this.$root.$notify.show(`No de puede cargar el detalle`, { color: 'info' });
            return {};
          });
      },

      generatePlan(value) {
        //if (!this.programa.nombre_compuesto) this.programa.nombre_compuesto = '';
        let programa = Object.assign(
          {
            id: this.inscripcion.id,
            idins: this.inscripcion.id,
            programa: { id: this.programa.id },
            estudiante: { id: this.inscripcion.estudiante.id },
            asesor: { id: this.inscripcion.asesor.id },
          },
          this.programa,
        );
        // selectInscripcion
        this.$store.dispatch('inscripcion/selectInscripcion', this.inscripcion);
        window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(programa));
        window.sessionStorage.setItem(
          'xprograma',
          JSON.stringify({
            id: programa.id,
            estudiante_id: this.inscripcion.estudiante.id,
            codigo: programa.nombre_compuesto,
            inscripcion_id: this.inscripcion.id,
            plan_pagos: this.inscripcion.plan_pagos,
          }),
        );
        value ? this.$router.push({ name: 'inscripcionrest' }) : this.$router.push({ name: 'regularizar' });
      },

      generatePlan2() {
        let programa = Object.assign(
          {
            id: this.inscripcion.id,
            programa: { id: this.programa.id },
            estudiante: { id: this.inscripcion.estudiante.id },
            asesor: { id: this.inscripcion.asesor.id },
          },
          this.programa,
        );
        // window.console.log('OLEEEEE:',this.programa);
        window.sessionStorage.setItem('xpreinscrito', JSON.stringify(this.inscripcion)); // es necesario para el cambio
        window.sessionStorage.setItem('xinscritotoplan', JSON.stringify(programa));
        window.sessionStorage.setItem(
          'xprograma',
          JSON.stringify({
            id: programa.id,
            codigo: programa.nombre_compuesto,
            inscripcion_id: this.inscripcion.id,
            plan_pagos: this.inscripcion.plan_pagos,
          }),
        );
        this.$router.push({ name: 'cambioplan' });
      },

      eliminarPlan() {
        const url = `${this.api_rest}/api/esam/inscripcion/plan/eliminar`;
        xaxios
          .post(url, { inscripcion_id: this.inscripcion.id })
          .then(() => {
            this.plan_pagos = [];
            this.cobro = null;
            this.$root.$notify.show(`${'Plan de Pagos  Eliminado del estudiante. Debe generar uno nuevo'}`, {
              color: 'info',
            });
          })
          .catch(({ response: { data } }) => this.$root.$notify.show(`${data.error}`, { color: 'danger' }));
      },
      getPromoAplicada(idins) {
        const url = `${this.api_rest}/api/v1/esam/promociones/${idins}/inscripcion`;
        xaxios
          .get(url, {})
          .then(({ data }) => {
            //window.console.log('getPromoAplicada: ', data.data);
            this.xpromo.id = data.data.id;
            this.xpromo.ambiente = data.data.ambiente;
            this.xpromo.aprobado_por = data.data.aprobado_por;
            this.xpromo.creado_por = data.data.creado_por;
            this.xpromo.descripcion = data.data.descripcion;
            this.xpromo.estado = data.data.estado;
            this.xpromo.fecha_fin = data.data.fecha_fin;
            this.xpromo.fecha_inicio = data.data.fecha_inicio;
            this.xpromo.nombre = data.data.nombre;
            this.xpromo.detalle_promocion = data.data.detalle_promocion;
          })
          .catch((e) => window.console.log(e));
      },
      closeDialog() {
        this.dialog = false;
        this.recibos = [];
        this.descuentos = [];
        this.$nextTick(() => {
          this.plan_pagos = [];
          this.existRecibo = false;
          this.planes_q = [];
          this.planes_q_cuotas = {};
          this.active_tab = 0;
        });
      },

      getMonedaStr(){
        let unidad = this.$store.state.CARGO.sede.unidad_negocio;
        if(unidad==14 || unidad == 15) return '$';
        return 'Bs.';
      },
      parseIns(ins) {
        var str = '';
        if (ins == 0) str = 'Pre inscrito';
        else if (ins == 1) str = 'Inscrito';
        else if (ins == 2) str = 'retirado';
        else if (ins == 3) str = 'cambiado';
        else if (ins == 4) str = 'congelado';
        else if (ins == 5) str = 'pagado';
        return str;
      },
      openAprobarDialog(plan) {
        this.planAprobar = plan;
        this.dialogAprobar = true;
      },
      async aprobarPlan() {
        if (!this.planAprobar) return;
        this.loading_aprobar = true;
        await xaxios
          .post(`${this.api_rest}/api/esam/inscripcion/plan/id/${this.planAprobar.id}/aprobar`, { user_id: this.$store.state.DATA_USER.id })
          .then(() => {
            this.$root.$notify.show(`Plan ${this.planAprobar.nro_plan} aprobado correctamente`, { color: 'success' });
            const plan = this.planes_q.find(p => p.id === this.planAprobar.id);
            if (plan) plan.aprobado = true;
            this.dialogAprobar = false;
            this.planAprobar = null;
          })
          .catch(({ response }) => {
            const msg = response && response.data && response.data.error ? response.data.error : 'Error al aprobar el plan';
            this.$root.$notify.show(msg, { color: 'danger' });
          });
        this.loading_aprobar = false;
      },
      async listar_descuentos_aprobados(){
        const unidad_negocio_id = this.$store.state.CARGO.sede.unidad_negocio;
        const sede_id = this.$store.state.CARGO.sede.id;
        const estudiante_id = this.inscripcion.estudiante.id;

        this.loading_descuentos = true;
        const url = `${this.api_rest}/api/v1/inscripcion/pagos/descuentos?descuento_tipo_id=2&is_asc=false&estado=aprobado&page=1&size=20&unidad_negocio_id=${unidad_negocio_id}&sede_id=${sede_id}&estudiante_id=${estudiante_id}`;
        const { data } = await xaxios.get(url).catch(() => ({ data: null }));
        this.loading_descuentos = false;
        this.descuentos = (data && data.data && data.data.items) ? data.data.items : [];
      },
      
      generar_nuevo_q() {
        if(!this.inscripcion) {
          this.$root.$notify.show('No se cargaron los datos de la inscripcion', {color:'red',x: 'right',});
          return
        }

        const ins = this.inscripcion;
        const idsede = this.$store.state.CARGO.sede.id
        const contiene_avd = this.programa.nombre_compuesto.includes('U301 AVANZADO)')
        window.console.log('contiene_avd', contiene_avd);

        if (idsede == 82 && contiene_avd) {
          const u = `/generar_plan_upi_q/${this.programa.id}?ins_id=${ins.id}&asesor_id=${ins.asesor.id}&doc=${ins.estudiante.num_doc}`
          this.$router.push(u);
          return;
        } else{
          this.$root.$notify.show('No es sede UPI panama o no es un AVANZADO', {color:'red',x: 'right',});
        }
      },
    },
  };
</script>
<style>
  .max-height {
    max-height: 4.5em;
  }
  .mora-mes-1 {
    background-color: #fb706d78;
  }
  .mora-semana-1 {
    background-color: #ffe17694;
  }
  .regularizado {
    background-color: #0076fb5e;
  }
  .descuento {
    background-color: #08fb005e;
  }
</style>
